"use client";

import React from 'react';
import AuthStateHandler from '@/components/property-review/atoms/AuthStateHandler';

interface AuthProviderProps {
  children: React.ReactNode;
  initialAuth?: {
    isAuthenticated: boolean;
    userType: 'tenant' | 'landlord' | null;
    userId?: string;
    userEmail?: string;
  };
}

export function AuthProvider({ children, initialAuth }: AuthProviderProps) {
  return (
    <AuthStateHandler initialAuth={initialAuth}>
      {children}
    </AuthStateHandler>
  );
} 